import { ErrorMessage } from '@hookform/error-message';
import type { FieldErrors, UseFormRegister } from 'react-hook-form-latest';

import TagsInput from '@/components/UI/TagsInput/TagsInput';
import Button from '@/components/UI/Button';

import { _isEmpty } from '@/littledash';

import { ID_METHODS, REPEATING, SEQUENTIAL } from '../Recaging.utils';
import type { ProposedCage, RecagingAnimal } from '../Recaging.utils';
import { PrefixAndSequenceForm } from './PrefixAndSequenceForm';

interface RecagingFormData {
  per_cage: number;
  sequencePrefix: string;
  sequenceStarting: string;
}

interface IdGenerationFormProps {
  errors: FieldErrors<RecagingFormData>;
  idGenerationMethod: string;
  onIdGenerationMethodChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  tags: string[];
  onTagChange: (newTags: string[]) => void;
  onGenerateIds: () => void;
  loading: boolean;
  studyCagesLoading: boolean;
  proposedCages: ProposedCage[];
  selectedSubjects: RecagingAnimal[];
  register: UseFormRegister<RecagingFormData>;
}

export const IdGenerationForm: React.FC<IdGenerationFormProps> = ({
  errors,
  idGenerationMethod,
  onIdGenerationMethodChange,
  tags,
  onTagChange,
  onGenerateIds,
  loading,
  studyCagesLoading,
  proposedCages,
  selectedSubjects,
  register,
}) => {
  return (
    <div className="ui-card w-60 pl3">
      <div className="mv3">
        <h3 className="lh-solid f4 pb3">New Animal IDs</h3>
        <div className="flex flex-row justify-between">
          <div>
            <label htmlFor="per_cage">Auto generate IDs</label>

            <div className="flex flex-row items-center">
              <div className="mr3">
                <select
                  name="id_generation"
                  disabled={loading || studyCagesLoading || _isEmpty(proposedCages)}
                  onChange={onIdGenerationMethodChange}
                  value={idGenerationMethod}
                  data-testid="id_generation"
                >
                  {ID_METHODS.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex justify-center">
                {idGenerationMethod === REPEATING && (
                  <div className="mr3" style={{ width: '28rem' }}>
                    <TagsInput value={tags} onChange={onTagChange} maxTags={10} onlyUnique testId="recaging-id-tags" />
                  </div>
                )}
                {idGenerationMethod === SEQUENTIAL && <PrefixAndSequenceForm register={register} errors={errors} />}
                <Button
                  className="w-100 mb3 w-auto-ns mb0-ns plain"
                  onClick={onGenerateIds}
                  disabled={
                    loading ||
                    studyCagesLoading ||
                    _isEmpty(proposedCages) ||
                    _isEmpty(selectedSubjects) ||
                    (idGenerationMethod === REPEATING && _isEmpty(tags))
                  }
                >
                  Bulk assign
                </Button>
              </div>
            </div>
          </div>
        </div>
        <ErrorMessage
          errors={errors}
          name="per_cage"
          render={({ message }) => <p className="f6 red db pt2">{message}</p>}
        />
      </div>
    </div>
  );
};
